export default __webpack_public_path__ + "static/media/honeyswap.d0e059b5.svg";